import React from 'react';
import { RtlProvider } from 'root/components/Menus/shared/RtlProvider/RtlProvider';
import { dataHooks } from 'root/dataHooks';

export const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <RtlProvider>
      <div data-hook={dataHooks.app.container}>{children}</div>
    </RtlProvider>
  );
};
